var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"color":_vm.type,"bottom":"","left":"","text":"","timeout":_vm.timeout},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},_vm._l((_vm.text.split('\n')),function(text,index){return _c('div',{key:index},[_vm._v("\n      "+_vm._s(text)+"\n    ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }